import { render, staticRenderFns } from "./TransferTab61.vue?vue&type=template&id=32b2fc75"
import script from "./TransferTab61.vue?vue&type=script&lang=js"
export * from "./TransferTab61.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports